"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Actions;
(function (Actions) {
    // Actions sent from the exercise app to Campus app
    Actions["CLIENT_READY"] = "CLIENT_READY";
    Actions["EXERCISE_READY"] = "EXERCISE_READY";
    Actions["SET_EXERCISE_STATUS"] = "SET_EXERCISE_STATUS";
    Actions["EXERCISE_FINISHED"] = "EXERCISE_FINISHED";
    Actions["EXERCISE_SUBMITTED"] = "EXERCISE_SUBMITTED";
    Actions["SET_EXERCISE_XP"] = "SET_EXERCISE_XP";
    // Actions sent from the Campus app to the exercise app
    Actions["SET_EXERCISE_PROPS"] = "SET_EXERCISE_PROPS";
})(Actions || (Actions = {}));
exports.default = Actions;
//# sourceMappingURL=Actions.js.map